import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug = false
window.Stimulus = application

const controllers = import.meta.glob("./**/*_controller.js", { eager: true })
Object.values(controllers).forEach((mod) => {
  if (mod && mod.default && mod.default.identifier) {
    application.register(mod.default.identifier, mod.default)
  }
})
